import { Reducer } from 'redux'
import { Action, ActionTypes } from 'mobile/Actions/actionConstants'
import {IResource} from "shared/Types/appTypes";

export interface IResourceDetailsModal {
    open: boolean
    resource: IResource | null
}

const initialState: IResourceDetailsModal = {
    open: false,
    resource: null,
};

const resourceDetailsModalReducer: Reducer<IResourceDetailsModal, Action> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.OPEN_RESOURCE_DETAILS_MODAL:
            return {
                ...state,
                open: true,
                resource: action.resource,
            };
        case ActionTypes.CLOSE_RESOURCE_DETAILS_MODAL:
            return {
                ...state,
                open: false,
            };
        default:
            return state
    }
};

export default resourceDetailsModalReducer
